// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3wJJ8","tab":"Tabs_tab__17uea","tabActive":"Tabs_tabActive__1bvQ7"};